import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from 'antd';
import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { DocumentTitle } from '../components';
import { KxHeader } from './Header';
import { Sider } from './Sider';
import { HelpWebModule } from '@core/support-block';
import '@core/support-block/style.css';
import { useSharedGlobalState } from '../hooks';
import { IIPHeader } from './Header/IIPHeader';
const { Content } = Layout;
const noSupportSystem = ['167096554103328853'];
export const BasicLayoutChildren = ({ sider = true, canChangeCompany = false, headerTabs = [], children, isShowHelpWebModule = true, layout, contentStyle, isBodySrcoll = false, headerType, }) => {
    const location = useLocation();
    const layoutType = new URLSearchParams(window.location.search).get('layout') ?? layout;
    const isSlider = !layoutType || layoutType == 'sider';
    const isHead = !layoutType || layoutType == 'head';
    const { systemId, authLoginType, 
    // @ts-ignore
    isShowAi } = useSharedGlobalState();
    const supportBlockIns = useRef(null);
    useEffect(() => {
        if (isShowAi &&
            isShowHelpWebModule &&
            systemId &&
            !supportBlockIns.current &&
            !noSupportSystem.includes(systemId) &&
            String(Number(systemId)) !== 'NaN' &&
            (authLoginType === 'KXGC' ||
                authLoginType === 'SCM' ||
                authLoginType === 'PSI')) {
            supportBlockIns.current = new HelpWebModule({
                systemId: systemId,
                slicePoint: 1,
            });
        }
        if (supportBlockIns.current) {
            supportBlockIns.current.setMenuCode('');
        }
    }, [systemId, location.pathname, isShowHelpWebModule, isShowAi]);
    useEffect(() => {
        if (!isBodySrcoll) {
            document.body.style.overflow = 'hidden';
        }
    }, [isBodySrcoll]);
    return (_jsxs(Layout, { children: [_jsx(DocumentTitle, {}), isHead ?
                headerType == 'iip'
                    ? _jsx(IIPHeader, {})
                    : _jsx(KxHeader, { isBodySrcoll: isBodySrcoll, canChangeCompany: canChangeCompany, headerTabs: headerTabs })
                : null, _jsxs(Layout, { style: { flexDirection: 'row' }, children: [isSlider ? _jsx(Sider, { layoutHeight: "calc(100vh - 48px)" }) : null, _jsx(Layout, { style: { minWidth: 0 }, children: _jsx(Content, { style: {
                                marginTop: isBodySrcoll && isHead ? 48 : 0,
                                ...isBodySrcoll ? {} : { overflow: 'auto' },
                                height: isHead ? 'calc(100vh - 48px)' : '100vh', ...contentStyle
                            }, children: children }) })] })] }));
};
export const BasicLayout = ({ canChangeCompany = false, headerTabs = [], }) => (_jsx(BasicLayoutChildren, { canChangeCompany: canChangeCompany, headerTabs: headerTabs, children: _jsx(Outlet, {}) }));
